import { Spaces } from '../../../../api/api-spaces';
import { Listings } from '../../../../api/api-listings';
import * as types from '../constants/action-types';
import { get, uniqBy } from 'lodash';


export function fetchSpacesRequest () {
  return {
    type: types.SPACES_FETCH_REQUEST
  };
}

export function fetchSpacesSuccess (data, total) {
  return {
    type: types.SPACES_FETCH_SUCCESS,
    data,
    total
  };
}

function fetchSpacesFailure (fetchError) {
  return {
    type: types.SPACES_FETCH_FAILURE,
    fetchError
  };
}

function clearSpacesData () {
  return {
    type: types.SPACES_CLEAR_STORE,
    data: []
  };
}

export function fetchOwnerSpacesInfo (query, accessToken) {
  return dispatch => {
    dispatch(fetchSpacesRequest());

    return Spaces.readV2(query, accessToken, (response) => {
      if (200 === response.statusCode) {
        const spaces = get(response, 'spaces', []);
        const total = get(response, 'total_count');
        return dispatch(fetchSpacesSuccess(spaces, total));
      }

      const fetchError = get(response, 'error', '');
      dispatch(fetchSpacesFailure(fetchError));
    });
  };
}

export function clearSpacesStore () {
  return dispatch => {
    dispatch(clearSpacesData());
  };
}


// Call to get all of ACTIVATED host spaces
export const fetchActiveSpaces = (SSOid, accessToken) => {
  const query = `owner/${SSOid}/status/ACTIVATED/?dropdown=true`;

  return dispatch => {
    dispatch(fetchSpacesRequest());
    // start fetching spaces by getting all user listings
    const fetchListings = () => {
      return new Promise((resolveListings, rejectListings) => {
        return Listings.queryListings(query, (response) => {
          if (200 !== response.statusCode) {
            dispatch(fetchSpacesFailure(response.error));
            return rejectListings();
          }
          const listings = get(response, ['listings'], []);
          return resolveListings(listings);
        });
      });
    };

    // get spaced ids from listings and string ids for query
    const getSpaceIds = (listings) => {
      const uniqueSpaces = uniqBy(listings, 'parentSpaceId');
      const stringIds = (array) => array.map(item => `ids=${item}`).join('&');
      return stringIds(uniqueSpaces.map((space) => space.parentSpaceId));
    };

    // start of Promise call chains
    return fetchListings()
      .then(getSpaceIds)
      .then((joinedIds) => {
        if (!joinedIds) return dispatch(fetchSpacesSuccess([], 0));

        return dispatch(fetchOwnerSpacesInfo(
          `owner/${SSOid}?no_deactivated=true&fields=summary&${joinedIds}`,
          accessToken
        ));
      })
      // `fetchListings` already dispatched the failure before rejecting; this
      // only keeps the rejection from surfacing as an unhandled one.
      .catch(() => {});
  };
};

export function updateSpace (spaceId, spaceObj) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { auth } = getState();
      dispatch({ type: types.SPACE_UPDATE_REQUEST });

      Spaces.update(spaceId, auth.accessToken, spaceObj, (response) => {
        if (response.error) {
          return reject(dispatch({
            type: types.SPACE_UPDATE_FAILURE,
            error: response.error
          }));
        }

        return resolve(dispatch({
          type: types.SPACE_UPDATE_SUCCESS,
          profile: response.profile
        }));
      });
    });
  };
}
